var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-9.13872e-07 25C2.93184e-07 11.1929 11.1929 -4.12394e-07 25 7.94663e-07C38.8071 2.00172e-06 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 -2.12093e-06 38.8071 -9.13872e-07 25Z",
    fill: "#1a76d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9875 25.4472L16.8946 35.4937C16.4991 35.6914 16.0604 35.3162 16.1945 34.8949L19.1982 25.4548C19.2923 25.1589 19.2923 24.8411 19.1982 24.5452L16.1945 15.1051C16.0604 14.6838 16.4991 14.3086 16.8946 14.5063L36.9875 24.5528C37.3561 24.737 37.3561 25.263 36.9875 25.4472Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEast);
export default __webpack_public_path__ + "static/media/east.e7fe05d7ec09e217b711322536f39d3a.svg";
export { ForwardRef as ReactComponent };